import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";


export default function ParishSelect({
  value,
  setField,
  field,
  required = false,
  classes,
  bold = false,
}) {
    const [parishList, setParishList] = React.useState([]);
    const { user } = useAuthContext();

    // load the list of parishes
    useEffect(() => {
        console.log("Loading parish list");
        const fetchData = async () => {
            const res = await axios.get(
                `https://${process.env.REACT_APP_IP}/api/parishdistricts`,
                {
                    headers: { Authorization: `bearer ${user.token}` },
                });

            setParishList(res.data.results);
        };
        fetchData();

        
        
    }, [user]);



  return (
    <Form.Group className={`mb-1 ${classes}`}>
      {bold ? (
        <Form.Label>
          <strong>Parish</strong>
        </Form.Label>
      ) : (
        <Form.Label>Parish</Form.Label>
      )}
      <Form.Select
        value={value ?? ""}
        required={required}
        onChange={(e) => setField(field, e.target.value)}
      >
        <option value="">All parishes</option>
        {parishList && parishList.map((parish) => (
            <option key={parish.parish} value={parish.parish}>
                {parish.parish}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
